module.exports = __webpack_public_path__ + "static/media/indent.d522f21f.svg";